export enum TimelineSortEnum {
  closest = 'closest',
  default = 'default',
  bookedASC = 'bookedASC'
}
